import React, { useState } from "react";
import "./VistaUsuarios.css";

function FiltroMenu({ isOpen, onClose, onAplicarFiltros }) {
  const [edadMin, setEdadMin] = useState(18);
  const [edadMax, setEdadMax] = useState(50);
  const [pais, setPais] = useState("Bolivia");
  const [departamento, setDepartamento] = useState("Todos");

  // Estados para controlar los efectos de hover
  const [hoverCerrar, setHoverCerrar] = useState(false);
  const [hoverAplicar, setHoverAplicar] = useState(false);

  // Listado completo de países con enlaces directos a banderas a color (SVG)
  const listadoPaises = {
    Bolivia: {
      bandera: "https://flagcdn.com/w40/bo.png",
      regiones: [
        "Todos",
        "La Paz",
        "Santa Cruz",
        "Cochabamba",
        "Oruro",
        "Potosí",
        "Tarija",
        "Sucre",
        "Beni",
        "Pando",
      ],
    },
    Chile: {
      bandera: "https://flagcdn.com/w40/cl.png",
      regiones: [
        "Todos",
        "Arica y Parinacota",
        "Tarapacá",
        "Antofagasta",
        "Atacama",
        "Coquimbo",
        "Valparaíso",
        "Santiago",
        "O'Higgins",
        "Maule",
        "Ñuble",
        "Biobío",
        "La Araucanía",
        "Los Ríos",
        "Los Lagos",
        "Aysén",
        "Magallanes",
      ],
    },
    Argentina: {
      bandera: "https://flagcdn.com/w40/ar.png",
      regiones: [
        "Todos",
        "Buenos Aires",
        "Catamarca",
        "Chaco",
        "Chubut",
        "Córdoba",
        "Corrientes",
        "Entre Ríos",
        "Formosa",
        "Jujuy",
        "La Pampa",
        "La Rioja",
        "Mendoza",
        "Misiones",
        "Neuquén",
        "Río Negro",
        "Salta",
        "San Juan",
        "San Luis",
        "Santa Cruz",
        "Santa Fe",
        "Santiago del Estero",
        "Tierra del Fuego",
        "Tucumán",
      ],
    },
    Colombia: {
      bandera: "https://flagcdn.com/w40/co.png",
      regiones: [
        "Todos",
        "Amazonas",
        "Antioquia",
        "Arauca",
        "Atlántico",
        "Bogotá D.C.",
        "Bolívar",
        "Boyacá",
        "Caldas",
        "Caquetá",
        "Casanare",
        "Cauca",
        "Cesar",
        "Chocó",
        "Córdoba",
        "Cundinamarca",
        "Guainía",
        "Guaviare",
        "Huila",
        "La Guajira",
        "Magdalena",
        "Meta",
        "Nariño",
        "Norte de Santander",
        "Putumayo",
        "Quindío",
        "Risaralda",
        "San Andrés y Providencia",
        "Santander",
        "Sucre",
        "Tolima",
        "Valle del Cauca",
        "Vaupés",
        "Vichada",
      ],
    },
    Perú: {
      bandera: "https://flagcdn.com/w40/pe.png",
      regiones: [
        "Todos",
        "Amazonas",
        "Áncash",
        "Apurímac",
        "Arequipa",
        "Ayacucho",
        "Cajamarca",
        "Callao",
        "Cusco",
        "Huancavelica",
        "Huánuco",
        "Ica",
        "Junín",
        "La Libertad",
        "Lambayeque",
        "Lima",
        "Loreto",
        "Madre de Dios",
        "Moquegua",
        "Pasco",
        "Piura",
        "Puno",
        "San Martín",
        "Tacna",
        "Tumbes",
        "Ucayali",
      ],
    },
  };

  if (!isOpen) return null;

  const handleAplicar = () => {
    if (onAplicarFiltros) {
      onAplicarFiltros({ edadMin, edadMax, pais, departamento });
    }
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#0b0f1a",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "24px 20px",
        boxSizing: "border-box",
        animation: "fadeIn 0.2s ease-out",
        fontFamily:
          'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      {/* SECCIÓN SUPERIOR: CABECERA Y FORMULARIOS */}
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* 1. CABECERA LIMPIA */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: "1.4rem",
                fontWeight: "800",
                color: "#ffffff",
                letterSpacing: "-0.3px",
              }}
            >
              Filtros
            </h2>
            <p
              style={{
                margin: "3px 0 0 0",
                fontSize: "0.8rem",
                color: "#94a3b8",
              }}
            >
              Ajusta los parámetros de búsqueda por país y región
            </p>
          </div>

          {/* Botón Cerrar con Efecto Hover */}
          <button
            onClick={onClose}
            aria-label="Cerrar"
            onMouseEnter={() => setHoverCerrar(true)}
            onMouseLeave={() => setHoverCerrar(false)}
            style={{
              background: hoverCerrar
                ? "rgba(225, 29, 72, 0.2)"
                : "rgba(255, 255, 255, 0.08)",
              border: hoverCerrar
                ? "1px solid rgba(225, 29, 72, 0.5)"
                : "1px solid rgba(255, 255, 255, 0.12)",
              color: hoverCerrar ? "#f43f5e" : "#ffffff",
              fontSize: "1.1rem",
              cursor: "pointer",
              width: "38px",
              height: "38px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.25s ease",
              transform: hoverCerrar
                ? "scale(1.1) rotate(90deg)"
                : "scale(1) rotate(0deg)",
            }}
          >
            ✕
          </button>
        </div>

        {/* 2. TARJETA RANGO DE EDAD */}
        <div
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.03)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "14px",
            }}
          >
            <span
              style={{
                fontSize: "0.9rem",
                color: "#e2e8f0",
                fontWeight: "600",
              }}
            >
              Rango de Edad
            </span>
            <span
              style={{
                backgroundColor: "rgba(225, 29, 72, 0.2)",
                color: "#fda4af",
                padding: "3px 10px",
                borderRadius: "12px",
                fontSize: "0.8rem",
                fontWeight: "700",
                border: "1px solid rgba(225, 29, 72, 0.35)",
              }}
            >
              {edadMin} - {edadMax} años
            </span>
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "0.75rem",
                  color: "#94a3b8",
                  marginBottom: "4px",
                }}
              >
                <span>Mínima</span>
                <span>{edadMin} años</span>
              </div>
              <input
                type="range"
                min="18"
                max="50"
                value={edadMin}
                onChange={(e) =>
                  setEdadMin(Math.min(Number(e.target.value), edadMax - 1))
                }
                style={{
                  width: "100%",
                  accentColor: "#e11d48",
                  cursor: "pointer",
                  height: "5px",
                }}
              />
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "0.75rem",
                  color: "#94a3b8",
                  marginBottom: "4px",
                }}
              >
                <span>Máxima</span>
                <span>{edadMax} años</span>
              </div>
              <input
                type="range"
                min="18"
                max="50"
                value={edadMax}
                onChange={(e) =>
                  setEdadMax(Math.max(Number(e.target.value), edadMin + 1))
                }
                style={{
                  width: "100%",
                  accentColor: "#e11d48",
                  cursor: "pointer",
                  height: "5px",
                }}
              />
            </div>
          </div>
        </div>

        {/* 3. TARJETA UBICACIÓN (PAÍS Y CIUDAD/DEPARTAMENTO EN PARALELO) */}
        <div
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.03)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            {/* Selector de País */}
            <div style={{ flex: "0 0 48%" }}>
              <label
                style={{
                  fontSize: "0.75rem",
                  color: "#94a3b8",
                  fontWeight: "600",
                  display: "block",
                  marginBottom: "6px",
                }}
              >
                País
              </label>
              <select
                value={pais}
                onChange={(e) => {
                  const nuevoPais = e.target.value;
                  setPais(nuevoPais);
                  setDepartamento(listadoPaises[nuevoPais].regiones[0]);
                }}
                style={{
                  width: "100%",
                  padding: "10px 10px",
                  backgroundColor: "#1e293b",
                  color: "#ffffff",
                  border: "1px solid rgba(255, 255, 255, 0.15)",
                  borderRadius: "10px",
                  fontSize: "0.85rem",
                  outline: "none",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {Object.keys(listadoPaises).map((p, idx) => (
                  <option
                    key={idx}
                    value={p}
                    style={{ backgroundColor: "#0f172a", color: "#ffffff" }}
                  >
                    {p}
                  </option>
                ))}
              </select>
            </div>

            {/* Selector de Departamento / Región dinámico */}
            <div style={{ flex: "1" }}>
              <label
                style={{
                  fontSize: "0.75rem",
                  color: "#94a3b8",
                  fontWeight: "600",
                  display: "block",
                  marginBottom: "6px",
                }}
              >
                Ciudad / Región
              </label>
              <select
                value={departamento}
                onChange={(e) => setDepartamento(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  backgroundColor: "#1e293b",
                  color: "#ffffff",
                  border: "1px solid rgba(255, 255, 255, 0.15)",
                  borderRadius: "10px",
                  fontSize: "0.85rem",
                  outline: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                {listadoPaises[pais].regiones.map((dep, idx) => (
                  <option
                    key={idx}
                    value={dep}
                    style={{ backgroundColor: "#0f172a", color: "#ffffff" }}
                  >
                    {dep}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* VISUALIZADOR DE LA BANDERA DEL PAÍS SELECCIONADO */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "12px",
            }}
          >
            <img
              src={listadoPaises[pais].bandera}
              alt={pais}
              style={{
                width: "24px",
                height: "16px",
                borderRadius: "3px",
                objectFit: "cover",
                boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}
            />
            <span
              style={{
                fontSize: "0.8rem",
                color: "#cbd5e1",
                fontWeight: "500",
              }}
            >
              Mostrando regiones de{" "}
              <strong style={{ color: "#ffffff" }}>{pais}</strong>
            </span>
          </div>
        </div>
      </div>

      {/* 4. BOTÓN APLICAR ABAJO DEL TODO */}
      <div
        style={{ marginTop: "auto", paddingTop: "16px", marginBottom: "15px" }}
      >
        <button
          onClick={handleAplicar}
          onMouseEnter={() => setHoverAplicar(true)}
          onMouseLeave={() => setHoverAplicar(false)}
          style={{
            width: "100%",
            padding: "14px",
            background: hoverAplicar
              ? "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)"
              : "linear-gradient(135deg, #e11d48 0%, #be123c 100%)",
            color: "#ffffff",
            border: "none",
            borderRadius: "14px",
            fontWeight: "700",
            fontSize: "1rem",
            cursor: "pointer",
            boxShadow: hoverAplicar
              ? "0 8px 25px rgba(225, 29, 72, 0.55)"
              : "0 4px 18px rgba(225, 29, 72, 0.35)",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            transform: hoverAplicar ? "translateY(-2px)" : "translateY(0)",
          }}
        >
          Aplicar Filtros
        </button>
      </div>
    </div>
  );
}

export default FiltroMenu;
